import React from 'react';

import LanguageSelectorImpl from 'components/language-selector';

export const FooterLanguageSelector: React.FC = () => (
  <LanguageSelectorImpl color={Styles.color.black} />
);
